module.exports = __webpack_public_path__ + "media/images/x-78b61a294431b59529bca13c9bdab99a.svg";